export default __webpack_public_path__ + "static/media/Viaduct-Active-01.6aa4cf0e.jpg";